// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__3m0mF","icon":"Item_icon__3o_7S","title":"Item_title__1w5k3","text":"Item_text__P7Sqo","cta":"Item_cta__3UvqB"};